<div class="row">
  <button (click)="goBack()" class="btn-tertiary-link text-start width-fit-content">
    <ucs-icon [class]="'blue tertiary-btn-icon'" [shape]="'angle_left'"></ucs-icon>
    {{ 'offer-detail.back-to-search' | translate }}
  </button>
</div>

